<div class="register-card">
  <div class="logo">
    <img src="/assets/logo-wm.png" height="50" alt="App Logo" />
  </div>
  <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Full Name</mat-label>
        <input matInput formControlName="fullName" type="text" id="fullName" name="fullName" required>
        <mat-error *ngIf="registrationForm.get('fullName')?.invalid && registrationForm.get('fullName')?.touched">
          <span *ngIf="registrationForm.get('fullName')?.errors?.['required']">This field is required.</span>
          <span *ngIf="registrationForm.get('fullName')?.errors?.['pattern']">Only letters, spaces, and hyphens allowed.</span>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" id="email" name="email" required>
        <mat-error *ngIf="registrationForm.get('email')?.invalid && registrationForm.get('email')?.touched">
          <span *ngIf="registrationForm.get('email')?.errors?.['required']">This field is required.</span>
          <span *ngIf="registrationForm.get('email')?.errors?.['email']">Please enter a valid email address.</span>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Country</mat-label>
        <input
          matInput
          formControlName="country"
          [matAutocomplete]="auto"
          placeholder="Select or type a country"
          (input)="onCountryChange()"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCountrySelected($event)">
          <mat-option *ngFor="let country of filteredCountries" [value]="country.name">
            {{ country.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="registrationForm.get('country')?.invalid && registrationForm.get('country')?.touched">
          Country is required.
        </mat-error>
      </mat-form-field>
    </div>

  <!-- Contenedor para Phone Code y Phone Number -->
  <div class="form-group phone-container">
    <!-- Campo Phone Code -->
    <mat-form-field appearance="outline" class="phone-code">
      <mat-label>Phone Code</mat-label>
      <input matInput formControlName="phoneCode" [readonly]="true" />
    </mat-form-field>

    <!-- Campo Phone Number -->
    <mat-form-field appearance="outline" class="phone-number">
      <mat-label>Phone Number</mat-label>
      <input matInput formControlName="phoneNumber" (input)="formatPhoneNumber($event)" type="text" />
      <mat-error *ngIf="registrationForm.get('phoneNumber')?.invalid && registrationForm.get('phoneNumber')?.touched">
        <span *ngIf="registrationForm.get('phoneNumber')?.errors?.['required']">This field is required.</span>
        <span *ngIf="registrationForm.get('phoneNumber')?.errors?.['pattern']">Please enter a valid phone number.</span>
      </mat-error>
    </mat-form-field>
  </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" type="password" required>
        <mat-error *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched">
          <span *ngIf="registrationForm.get('password')?.errors?.['required']">This field is required.</span>
          <span *ngIf="registrationForm.get('password')?.errors?.['minlength']">Password must be at least 8 characters long.</span>
          <span *ngIf="registrationForm.get('password')?.errors?.['pattern']">
            Must contain uppercase, number, and special character.
          </span>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Repeat Password</mat-label>
        <input
          matInput
          formControlName="repeatPassword"
          type="password"
          required
          (focus)="onFocus()"
          (input)="checkPasswords()"
        />
        <mat-error *ngIf="registrationForm.get('repeatPassword')?.hasError('passwordMismatch') || (registrationForm.get('repeatPassword')?.hasError('required') && registrationForm.get('repeatPassword')?.touched)">
          Passwords do not match or field is required.
        </mat-error>
        <mat-icon *ngIf="isPasswordValid()" class="check-icon">check_circle</mat-icon>
      </mat-form-field>
    </div>
    <div class="form-group">
      <button [disabled]="registrationForm.invalid || !isPasswordValid()" mat-raised-button color="primary" type="submit" class="full-width">Sign Up</button>
    </div>
    <div class="create-account">
      <p>Already have an account? <a href="/auth/login">Sign In</a></p>
    </div>
  </form>
</div>
